import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { ECommissionType } from '../../../../api-models/common/json_query';

const ID = 'commissionType' as const;

const COMMISSION_LABELS: Record<ECommissionType, string> = {
  [ECommissionType.WithoutDeposit]: 'Без комиссии',
  [ECommissionType.Exclusive]: 'Эксклюзивная',
};

export const commissionTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const value = getTermValue('commission_type')(jsonQuery);

    if (value == null) {
      return null;
    }

    const label = COMMISSION_LABELS[value as ECommissionType];

    return label ? [{ label, value: ID }] : null;
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['commission_type'])(jsonQuery),
};
